import { en } from './en'
import { fr } from './fr'

export const table = {
  en,
  fr
}